import React from "react";
import foto from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-progreso-para-la-humanidad-dedicacion-movilidad.webp";

/*eslint-disable */

declare const window: any;
const ProgresoComponent: React.FC = () => {
  return (
    <div className="progreso-para-la-humanidad">
      <div className="left">
        <img 
          src={foto} 
          alt="Progreso para la Humanidad - Dedicación y movilidad" 
        />
      </div>
      <div className="right">
        {/* H2 - Título de la sección */}
        <h2 className="title">Progreso para la Humanidad</h2>
        
        {/* H3 - Descripción (como subtítulo importante) */}
        <h3 className="description">
          Nuestra dedicación por el progreso de la humanidad se refleja en todo lo que hacemos, inspirándonos a concebir, crear y diseñar vehículos que abran nuevos capítulos en la movilidad y ayuden a redefinir nuestro viaje como comunidad global.
        </h3>
      </div>
    </div>
  );
};

export default ProgresoComponent;